<!-- 以下是为了解决因为fixed定位导致 sidebar展开导航栏的动画不显示问题 -->
<!-- <template>
  <div id="app">
    <AppHeader @toggle-menu="toggleMenu" />
    <div v-if="isMenuOpen" class="sidebar">
      <div class="close-icon" @click="toggleMenu"></div>
      <div>
        <div class="nav-item" :class="{ 'animate__animated animate__fadeInRight': isMenuOpen }" style="animation-delay: 0s" @click="goTo('HomePage')">Home</div>
        <div class="nav-item" :class="{ 'animate__animated animate__fadeInRight': isMenuOpen }" style="animation-delay: 0.1s" @click="goTo('AppServices')">Services</div>
        <div class="nav-item" :class="{ 'animate__animated animate__fadeInRight': isMenuOpen }" style="animation-delay: 0.2s" @click="goTo('AppAbout')">About</div>
        <div class="nav-item" :class="{ 'animate__animated animate__fadeInRight': isMenuOpen }" style="animation-delay: 0.3s" @click="goTo('AppContact')">Contact</div>
      </div>
    </div>
    <router-view></router-view>
    <AppFooter />
  </div>
</template>

<script setup>
 /* eslint-disable */ 

import { ref, watch, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';

const router = useRouter();
const route = useRoute();
const isMenuOpen = ref(false);

// 监听 isMenuOpen 的变化
watch(isMenuOpen, (newVal) => {
  if (newVal) {
    nextTick(() => {
      // 手动触发动画
      const navItems = document.querySelectorAll('.nav-item');
      navItems.forEach((item, index) => {
        // 设置动画延迟
        item.style.animationDelay = `${index * 0.1}s`;
        // 添加动画类
        item.classList.add('animate__animated', 'animate__fadeInRight');
      });
    });
  } else {
    // 关闭菜单时移除动画类
    const navItems = document.querySelectorAll('.nav-item');
    navItems.forEach((item) => {
      item.classList.remove('animate__animated', 'animate__fadeInRight');
    });
  }
});

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const goTo = (name) => {
  isMenuOpen.value = false;
  router.push({ name });
};
</script>

<style lang="less" scoped>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: hsla(0, 0%, 100%, .85);
  color: white;
  z-index: 999;
  color: #1a2e42;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-weight: 500;
  font-size: 18px;
  text-transform: uppercase;
  animation: fadeInZoom 0.3s ease forwards;

  >div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    >div{
      padding: 15% 100%;
      &:hover{
        background-color: rgba(0,0,0,.06);
      }
    }
  }
}

.nav-item {
  cursor: pointer;
}
.close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  cursor: pointer;
  background-color: rgba(0,0,0,.15);
  border-radius: 50%;
}

.close-icon::before,
.close-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 30px;
  height: 3px;
  background-color: #1a2e42;
  transform: translate(-50%, -50%);
}

.close-icon::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close-icon::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}
@keyframes fadeInZoom {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style> -->




<template>
  <div id="app">
    <AppHeader @toggle-menu="toggleMenu" />
    <!-- <Teleport to="body">
      <div v-if="isMenuOpen" class="sidebar">
      <div class="close-icon" @click="toggleMenu"></div>
      <div style="overflow: hidden;padding: 0px 60px;">
        <div class="nav-item" :style="{ animationDelay: `${index * 0.1}s` }" @click="goTo('HomePage')" :data-index="0">
          Home</div>
        <div class="nav-item" :style="{ animationDelay: `${index * 0.1}s` }" @click="goTo('AppServices')"
          :data-index="1">Services</div>
        <div class="nav-item" :style="{ animationDelay: `${index * 0.1}s` }" @click="goTo('AppAbout')" :data-index="2">
          About</div>
        <div class="nav-item" :style="{ animationDelay: `${index * 0.1}s` }" @click="goTo('AppContact')"
          :data-index="3">Contact</div>
      </div>
    </div>
    </Teleport> -->
    <div v-if="isMenuOpen" class="sidebar">
      <div class="close-icon" @click="toggleMenu"></div>
      <div style="overflow: hidden;padding: 0px 60px;">
        <div class="nav-item" @click="goTo('HomePage')">Home</div>
        <div class="nav-item" @click="goTo('AppServices')">Services</div>
        <div class="nav-item" @click="goTo('AppAbout')">About</div>
        <div class="nav-item" @click="goTo('AppContact')">Contact</div>
      </div>
    </div>
    <router-view></router-view>
    <AppFooter />
  </div>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';

const router = useRouter();
const isMenuOpen = ref(false);

// 监听 isMenuOpen 的变化
watch(isMenuOpen, (newVal) => {
  if (newVal) {
    document.body.style.overflow = 'hidden';
    nextTick(() => {
      // 手动触发动画
      const navItems = document.querySelectorAll('.nav-item');
      navItems.forEach((item, index) => {
        // 设置动画延迟
        item.style.animationDelay = `${index * 0.1}s`;
        // 添加动画类
        item.classList.add('slide-in');
      });
    });
  } else {
    document.body.style.overflow = '';
    // 关闭菜单时移除动画类
    const navItems = document.querySelectorAll('.nav-item');
    navItems.forEach((item) => {
      item.classList.remove('slide-in');
      // 重置动画延迟
      item.style.animationDelay = '';
    });
  }
});

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const goTo = (name) => {
  isMenuOpen.value = false;
  router.push({ name });
};

/**
 * 总结--- iOS兼容性问题导致元素动画结束后跳变消失；
 * 首选方案：使用 JavaScript 监听 animationend 事件，手动设置最终状态。
 * 备用方案：针对 iOS 设备禁用 forwards，或使用 setTimeout 模拟 forwards。
 * 优化方案：避免 opacity 和 transform 的组合，或使用 translate3d 强制硬件加速。
 * const navItem = document.querySelector('.nav-item');
 * // 设置动画时长（与 CSS 动画时长一致）
 * const animationDuration = 800; // 0.8s
 * // 在动画结束后手动设置最终状态
 * setTimeout(() => {
 *   navItem.style.opacity = '1';
 *   navItem.style.transform = 'translateX(0)';
 * }, animationDuration);
 */
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  overflow: hidden;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: hsla(0, 0%, 100%, .85);
  color: white;
  z-index: 999;
  color: #1a2e42;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-weight: 500;
  font-size: 18px;
  text-transform: uppercase;
  animation: fadeInZoom 0.3s ease forwards;
  -webkit-animation: fadeInZoom 0.3s ease forwards;
  -moz-animation: fadeInZoom 0.3s ease forwards;
  overflow: hidden;

  transform: translateZ(0);/* 强制硬件加速 */
  -webkit-transform:translateZ(0);/* 强制硬件加速 */
  top: -1px;

  >div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

.nav-item {
  cursor: pointer;
  // opacity: 0.01; /* 避免完全透明-iOS 渲染问题 */
  transform: translateX(100%);
  animation: slide-in 0.8s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
  -webkit-animation: slide-in 0.8s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
  -moz-animation: slide-in 0.8s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
  width: 180px;
  padding: 15px 0px; /* 使用固定值 */
  &:hover {
    background-color: rgba(0, 0, 0, .08);
  }
}

.close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, .15);
  border-radius: 50%;
}

.close-icon::before,
.close-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 30px;
  height: 3px;
  background-color: #1a2e42;
  transform: translate(-50%, -50%);
}

.close-icon::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close-icon::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

@keyframes fadeInZoom {
  0% {
    opacity: 0.01;
    transform: scale(0.8);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slide-in {
  0% {
    // opacity: 0.01;
    transform: translateX(100%);
  }

  100% {
    // opacity: 1;
    transform: translateX(0);
  }
}

@-webkit-keyframes slide-in {
  0% {
    // opacity: 0.01;
    transform: translateX(100%);
  }

  100% {
    // opacity: 1;
    transform: translateX(0);
  }
}

@-moz-keyframes slide-in {
  0% {
    // opacity: 0.01;
    transform: translateX(100%);
  }

  100% {
    // opacity: 1;
    transform: translateX(0);
  }
}
</style>